module.exports = __webpack_public_path__ + "img/mynewsimg5.cb4f2ab5.png";